import React from 'react';
import classes from './TranscriptionTab.module.scss';
import Spinner from 'components/Spinner/Spinner';
import { Button, Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignCenter } from '@fortawesome/free-solid-svg-icons';
import Transcription from './Transcription';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setSessionStatus, setTranscription } from 'store/slices/aiFunctionsDataSlice';
import api from 'api';

type TranscriptionTabProps = {};

const TranscriptionTab = ({}: TranscriptionTabProps) => {
  const [sendingOnTranscription, setSendingOnTranscription] = React.useState(false);

  const { selectedDocument } = useAppSelector((state) => state.documents);
  const { transcription, isTranscriptionChecking, sessionStatus } = useAppSelector((state) => state.aiFunctions);
  const { messageApi } = useAppSelector((state) => state.windowState);

  const transcriptionStatus = transcription?.status || 'unavailable';
  const loadingStatusText = sessionStatus || 'in_progress';

  const dispatch = useAppDispatch();  
  const { t } = useTranslation();

  const sendForTranscription = async () => {
    setSendingOnTranscription(true);
    try {
      const transcriptionStatus = await api.sendOnTranscription({document_id: selectedDocument!.id});
      dispatch(setTranscription(transcriptionStatus.data));
      dispatch(setSessionStatus('init_transcription'));
    } catch {
      messageApi?.error(t('Documents.details.transcription.errorSending'))
    } finally {
      setSendingOnTranscription(false);
    }
  };
   
  const cases = {
    unavailable: (
      <div className={classes.holder}>
        <Empty
          className={classes.noTrascription}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<span>{t('Documents.details.transcription.empty')}</span>}
        />
      </div>
    ),
    not_found: (
      <div className={classes.holder}>
        <Empty
          className={classes.noTrascription}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={<span>{t('Documents.details.transcription.empty')}</span>}
        />
        <Button
          loading={sendingOnTranscription}
          icon={<FontAwesomeIcon rotation={270} icon={faAlignCenter} />}
          className={classes.addTrascription}
          type='primary'
          onClick={sendForTranscription}
        >
          {t('Documents.details.transcription.add')}
        </Button>
      </div>
    ),
    in_progress: (
      <div className={classes.holder}>
        <Spinner size={60} withLogo={true} height={60}/>
        <div className={classes.text}>{t(`Documents.details.transcription.${loadingStatusText}`)}</div>
      </div>
    ),
    ready: <Transcription />,
  };

  return (
    <div className={classes.transcriptionWrap}>
      { isTranscriptionChecking
        ? <div className={classes.holder}>
          <Spinner size={60} withLogo={true} height={60}/>
          <div className={classes.text}>{t('Documents.details.transcription.check')}</div>
        </div>
        : (
          <div style={{height: '100%'}}>
            {cases[transcriptionStatus as keyof typeof cases]}
          </div>
        )
      }
    </div>
  );
}

export default TranscriptionTab;
